import { globalData } from '../common/config'
const mainPlanNameList = {
  "PL1800205": "团体意外险",
  "PL1800037": "团意险",
  "PL1100412": "工程险"
}
export const getDutyList = (planList:any[]) => {
  let dutyList:any[] = []
  let dutyPlanMap = {};
  for(const plan of planList){
    const planCode = plan['planCode']
    const mustChoose = plan['mustChoosePlan']
    const planChineseName = plan['planChineseName']
    const isMain = plan['isMain']
    const dutyLen = (plan['dutyList'] || []).length;
    dutyPlanMap[planCode] = dutyLen;
    globalData['planInfo'][planCode] = plan
    for(const duty of plan['dutyList']){
      duty['planCode'] = planCode;
      duty['mustChoose'] = mustChoose
      duty['planChineseName'] = planChineseName
      duty['isMain'] = isMain
      duty['planRowSpan'] = dutyLen;
      if (plan.hasOwnProperty('planSeq')) {
        duty['planSeq'] = plan['planSeq'];
      }
      dutyList.push(duty)
    }
  }
  
  // dutyPlanMap 用来记录一个险种下面有几个责任
  for(const duty of dutyList){
    let planCode = duty.planCode;
    duty.planRowSpan = dutyPlanMap[planCode];
    if (dutyPlanMap[planCode] > 0) {
      dutyPlanMap[planCode] = 0;
    }
  }
  return dutyList
}

export const formatDutyList = (planList:any[], mainPlan:any) => {
  let dutyList:any[] = [];
  let newPlanList:any[] = [].concat((planList as any) || []);
  newPlanList.forEach((plan:any) => {
    const planChineseName = plan['planChineseName']
    const isMain = plan['isMain']
    const planCode = plan['planCode'] || ""
    plan['dutyList'].forEach((duty:any) => {
      duty['planCode'] = planCode;
      duty['mainPlanCode'] = mainPlan["planCode"];
      duty['mainPlanChineseName'] = mainPlan["planChineseName"];
      duty['mustChoose'] = plan['mustChoosePlan'];
      duty['planChineseName'] = planChineseName;
      duty['planNameType'] = mainPlanNameList[planCode] || planChineseName;
      duty['isMain'] = isMain;
      dutyList.push(duty);
    });
  });
  return dutyList
}

export const reverseString = (str:string) => {
  return Array.prototype.slice.call(str).reverse().join('');
}

export const transToNumber = (str:string) => {
  return Number(reverseString(parseInt(reverseString(str)) + ""));
}

export const getNewRelationShip = (relation:any, planList?:any[]) => {
  if (planList) {
    // 主险在不配置附加险的时候，planMainAdditionRel中就没有这个主险中，这时候需要添加进去
    (planList || []).forEach(plan => {
      if (plan.isMain === "1" && !relation[plan.planCode]) {
        relation[plan.planCode] = plan.additionCode || [];
      }
    })
  }
  if (globalData["productCode"] === "P060030" || globalData["productCode"] === "P060039") {
    const mainCodeArrs = Object.keys(relation);
    let addition_PL1800205 = relation["PL1800205"] || [];
    // "PL1800205"、"PL1800047"、"PL1800208"归并为"PL1800205" 平安产险意外伤害保险SME（互联网版）
    for (const key in relation) {
      if (key === "PL1800047" || key === "PL1800208") addition_PL1800205 = addition_PL1800205.concat([key], relation[key]);
    }
    // 根据主险附加险进行排序
    addition_PL1800205 = addition_PL1800205.sort((a, b) => {
      let index_a = mainCodeArrs.indexOf(a);
      let index_b = mainCodeArrs.indexOf(b);
      let order_a:any = transToNumber(a);
      let order_b:any = transToNumber(b);
      if (index_b > -1 && index_a === -1 || (index_b === -1 && index_a > -1)) {
        return index_b - index_a;
      } else {
        return order_a - order_b;
      }
    });
    // P060039中意健险种中 "PL1800205", "PL1800206", "PL1800216", "PL1800258" 这几个险种需要有多个职业类型
    if (globalData["productCode"] === "P060039") {
      const relationProfessionPlanCode = ["PL1800205", "PL1800206", "PL1800216", "PL1800258"];
      let relationCodes:string[] = addition_PL1800205.filter(code => relationProfessionPlanCode.includes(code));
      let noRelationCodes:string[] = addition_PL1800205.filter(code => !relationProfessionPlanCode.includes(code));
      addition_PL1800205 = relationCodes.concat(noRelationCodes);
    }
    if (addition_PL1800205.length > 0) {
      relation["PL1800205"] = addition_PL1800205;
    }
    if (mainCodeArrs.includes("PL1800047")) delete relation["PL1800047"];
    if (mainCodeArrs.includes("PL1800208")) delete relation["PL1800208"];
  }
  return relation;
}

export const getNewDutyList = (planList:any, hideAreaTarget?:boolean) => {
  const appProductInfo = Object.assign({}, globalData["appProductInfo"] || {});
  const planMainAdditionRel = Object.assign({}, appProductInfo["planMainAdditionRel"] || {});
  // 如果主险配置了附加险种，则会出现在planMainAdditionRel中，否则不会，这个时候要给他补上
  let newRelations = {};
  if (globalData["productCode"] === "P060039") {
    newRelations = getNewRelationShip(planMainAdditionRel, planList);
  } else if (globalData.aliProductCodes.includes(globalData['productCode'])) {
    // 理论上是可以共用newRelations =  getNewRelationShip(planMainAdditionRel, planList);这段逻辑，因为P060089已经上线，为了防止影响他的功能，保持不变
    if (globalData['productCode'] === "P060089") {
      newRelations = { PL0400446: [], PL0700902: [], PL0701847: [] }
    } else if (globalData['productCode'] === "P060091") {
      // 不需要把附加险合并到主险下面
      newRelations = { PL0400446: [], PL1000107: [], PL0700902: [], PL0701847: [] };
    } else {
      newRelations =  getNewRelationShip(planMainAdditionRel, planList);
    }
  } else {
    newRelations = getNewRelationShip(planMainAdditionRel);
  }
  let dutyList:any[] = [];
  if (planList) {
    if (globalData['productCode'] === "P060091") {
      // 按照UI上的样式进行排序
      planList.forEach(p => {
        if (p.planCode === "PL0400446") {
          p.sortNo = 1;
        } else if (p.planCode === "PL1000107") {
          p.sortNo = 2;
        } else if (p.planCode === "PL0700902") {
          p.sortNo = 3;
        } else if (p.planCode === "PL0701847") {
          p.sortNo = 4;
        }
      })
      planList.sort((planA, planB) => {
        return planA.sortNo - planB.sortNo;
      });
    } else {
      // 按照PL进行排序
      planList.sort((planA, planB) => {
        let A = transToNumber(planA.planCode);
        let B = transToNumber(planB.planCode);
        return A - B;
      });
    }
    for(const plan of planList){
      // 电商保由于生产环境和测试环境的排序不一致，所以需要对责任进行重新排序
      if (globalData['aliProductCodes'].includes(globalData['productCode'])) {
        plan.dutyList.sort((a, b) => {
          if (a.dutyCode > b.dutyCode) {
            return 1;
          } else {
            return -1;
          }
        })
      }
      const planCode = plan['planCode'];
      plan["newAdditionCode"] = newRelations[planCode] || null;
      if (plan["newAdditionCode"]) {
        // 主险
        let mainDuty = formatDutyList([plan], plan);
        // 附加险(按照newRelations顺序进行排序)
        let additionalPlan = planList.filter(item => plan["newAdditionCode"].includes(item.planCode)).sort((a, b) => {
          return plan["newAdditionCode"].indexOf(a["planCode"]) - plan["newAdditionCode"].indexOf(b["planCode"]);
        });
        let additionalDuty = formatDutyList(additionalPlan, plan);
        let totalDutyList:any[] = [];
        totalDutyList = totalDutyList.concat(mainDuty, additionalDuty);
        if (planCode === "PL1000006" && !hideAreaTarget) {
          totalDutyList.unshift({
            dutyCode: "sellingArea",
            isMain: "1",
            mainPlanChineseName: "公众责任保险",
            mainPlanCode: "PL1000006",
            mustChoose: "1",
            planChineseName: "营业面积",
            planCode: "sellingArea",
            planNameType: "公众责任保险",
            dutyChineseName: "营业面积",
            amountArangeMap: { amount: 0, rangeList: [], dutyAttrAmountValue: 0 }
          });
        }
        if (globalData["productCode"] === "P060039") {
          if (planCode === "PL1800205") {
            totalDutyList.unshift({
              dutyCode: "professionType",
              isMain: "1",
              mainPlanChineseName: "团体意外险",
              mainPlanCode: "PL1800205",
              mustChoose: "0",
              planChineseName: "职业类型",
              planCode: "professionType",
              planNameType: "团体意外险",
              dutyChineseName: "职业类型",
              amountArangeMap: { amount: 0, rangeList: [], dutyAttrAmountValue: 0 }
            }, {
              dutyCode: "insurantNumber",
              isMain: "1",
              mainPlanChineseName: "团体意外险",
              mainPlanCode: "PL1800205",
              mustChoose: "0",
              planChineseName: "被保险人数",
              planCode: "insurantNumber",
              planNameType: "团体意外险",
              dutyChineseName: "被保险人数",
              amountArangeMap: { amount: 0, rangeList: [], dutyAttrAmountValue: 0 }
            });
          }
        }
        let rowSpan = totalDutyList.length || 0; // 险种类别rowSpan
        totalDutyList.forEach((duty:any[], index) => {
          let tempDutyList = totalDutyList.filter(item => item["planCode"] === duty["planCode"]);
          let idx = tempDutyList.findIndex(item => item["dutyCode"] === duty["dutyCode"]);
          duty["rowSpanPlanName"] = idx === 0 ? tempDutyList.length : 0;
          duty["rowSpan"] = index === 0 ? rowSpan : 0;
        })
        // 险种名称纵向合并单元格
        dutyList = dutyList.concat(totalDutyList);
      } 
      globalData['planInfo'][planCode] = JSON.parse(JSON.stringify(plan));
    }
  }
  return dutyList;
}

// 低于可选值中最小值，展示最小值；大于可选值中最大值，展示最大值
export const defaultValFun = (num: number, numArr: number[]) => {
  if (num < numArr[0]) {
    return numArr[0];
  } else if (num > numArr[numArr.length - 1]) {
    return numArr[numArr.length - 1];
  } else {
    return num;
  }
};

export const getTableDataWithProfessionByDutyCode = (optAttributeVals: any[], dutyInfo: any, professionType: number) => {
  // 没有标识判断当前责任项下拉框选项类别是“承保、不承保”还是“金额范围”，只能根据dutyAttributeInfoList的长度判断。业务乱配数据很大风险会出错
  let dataObj = {}; //暂存当前责任项1-6类职业下拉框选项，如：dataObj[0]为当前责任项“一类职业”下拉框选项
  let defaultValueObj = {}; //暂存当前责任项1-6类职业下拉框默认值
  let optAttributeVal: any[] = optAttributeVals;
  const {dutyAttributeInfoList, dutyCode, amountUnit, mustChoose} = dutyInfo || {};
  if((dutyAttributeInfoList || []).length >= 1){
    // 意外身故、残疾 1-6类职业对应412~417的下拉选项 如果可选值中存在0，将0剔除，不展示
    if(dutyCode === 'CV00244'){
      dutyAttributeInfoList.map(el => {
        let optAttributeVal=el.optionalAttributeValue.split(',');
        if(mustChoose === '1'){  //1,表示剔除不承保
          optAttributeVal[0] == 0 && optAttributeVal.splice(0,1) //选项将 将0剔除  
        } else {
          (optAttributeVal[0] == 0) && optAttributeVal.splice(0, 1, -1); // 选项将 0改为-1
          (optAttributeVal[0] != -1) && optAttributeVal.unshift(-1)
        }
        if(el.dutyAttrCode === '412'){
          // 对应一类职业
          defaultValueObj[0] = defaultValFun(Number(el.dutyAttrAmountValue),optAttributeVal)
          dataObj[0] = optAttributeVal.map(item => {
            if(item == -1) {
              return {text:`不承保`,value:Number(item)} //-1对应的text是“不承保”
            } else {
              return {text:`${item/10000}万${amountUnit}`,value:Number(item)}
            }
          })
        }
        if(el.dutyAttrCode === '413'){
          // 对应二类职业
          defaultValueObj[1] = defaultValFun(Number(el.dutyAttrAmountValue),optAttributeVal)
          dataObj[1] = optAttributeVal.map(item => {
            if(item == -1) {
              return {text:`不承保`,value:Number(item)} //-1对应的text是“不承保”
            } else {
              return {text:`${item/10000}万${amountUnit}`,value:Number(item)}
            }
          })
        }
        if(el.dutyAttrCode === '414'){
          // 对应三类职业
          defaultValueObj[2] = defaultValFun(Number(el.dutyAttrAmountValue),optAttributeVal)
          dataObj[2] = optAttributeVal.map(item => {
            if(item == -1) {
              return {text:`不承保`,value:Number(item)} //-1对应的text是“不承保”
            } else {
              return {text:`${item/10000}万${amountUnit}`,value:Number(item)}
            }
          })
        }
        if(el.dutyAttrCode === '415'){
          // 对应四类职业
          defaultValueObj[3] = defaultValFun(Number(el.dutyAttrAmountValue),optAttributeVal)
          dataObj[3] = optAttributeVal.map(item => {
            if(item == -1) {
              return {text:`不承保`,value:Number(item)} //-1对应的text是“不承保”
            } else {
              return {text:`${item/10000}万${amountUnit}`,value:Number(item)}
            }
          })
        }
        if(el.dutyAttrCode === '416'){
          // 对应五类职业
          defaultValueObj[4] = defaultValFun(Number(el.dutyAttrAmountValue),optAttributeVal)
          dataObj[4] = optAttributeVal.map(item => {
            if(item == -1) {
              return {text:`不承保`,value:Number(item)} //-1对应的text是“不承保”
            } else {
              return {text:`${item/10000}万${amountUnit}`,value:Number(item)}
            }
          })
        }
        if(el.dutyAttrCode === '417'){
          // 对应六类职业
          defaultValueObj[5] = defaultValFun(Number(el.dutyAttrAmountValue),optAttributeVal)
          dataObj[5] = optAttributeVal.map(item => {
            if(item == -1) {
              return {text:`不承保`,value:Number(item)} //-1对应的text是“不承保”
            } else {
              return {text:`${item/10000}万${amountUnit}`,value:Number(item)}
            }
          })
        }
      })
    }

    // 意外伤害医疗 1-6类职业对应418~423的下拉选项 如果可选值中存在0，将0展示为“不承保”
    if(dutyCode === 'CVYB001'){
      dutyAttributeInfoList.map(el => {
        let optAttributeVal=el.optionalAttributeValue.split(',')
        if(mustChoose === '1'){  //1,表示剔除不承保
          optAttributeVal[0] == 0 && optAttributeVal.splice(0, 1) //选项将 将0剔除  
        } else {
          (optAttributeVal[0] == 0) && optAttributeVal.splice(0, 1, -1); // 选项将 0改为-1
          (optAttributeVal[0] != -1) && optAttributeVal.unshift(-1)
        }
        el.dutyAttrAmountValue = el.dutyAttrAmountValue==0?-1:el.dutyAttrAmountValue //默认值将 0改为-1
        if(el.dutyAttrCode === '418'){
          defaultValueObj[0] = defaultValFun(Number(el.dutyAttrAmountValue),optAttributeVal)
          dataObj[0] = optAttributeVal.map(item => {
            if(item == -1) {
              return {text:`不承保`,value:Number(item)} //-1对应的text是“不承保”
            } else {
              return {text:`${item/10000}万${amountUnit}`,value:Number(item)}
            }
          })
        }
        if(el.dutyAttrCode === '419'){
          defaultValueObj[1] = defaultValFun(Number(el.dutyAttrAmountValue),optAttributeVal)
          dataObj[1] = optAttributeVal.map(item => {
            if(item == -1) {
              return {text:`不承保`,value:Number(item)}
            } else {
              return {text:`${item/10000}万${amountUnit}`,value:Number(item)}
            }
          })
        }
        if(el.dutyAttrCode === '420'){
          defaultValueObj[2] = defaultValFun(Number(el.dutyAttrAmountValue),optAttributeVal)
          dataObj[2] = optAttributeVal.map(item => {
            if(item == -1) {
              return {text:`不承保`,value:Number(item)}
            } else {
              return {text:`${item/10000}万${amountUnit}`,value:Number(item)}
            }
          })
        }
        if(el.dutyAttrCode === '421'){
          defaultValueObj[3] = defaultValFun(Number(el.dutyAttrAmountValue),optAttributeVal)
          dataObj[3] = optAttributeVal.map(item => {
            if(item == -1) {
              return {text:`不承保`,value:Number(item)}
            } else {
              return {text:`${item/10000}万${amountUnit}`,value:Number(item)}
            }
          })
        }
        if(el.dutyAttrCode === '422'){
          defaultValueObj[4] = defaultValFun(Number(el.dutyAttrAmountValue),optAttributeVal)
          dataObj[4] = optAttributeVal.map(item => {
            if(item == -1) {
              return {text:`不承保`,value:Number(item)}
            } else {
              return {text:`${item/10000}万${amountUnit}`,value:Number(item)}
            }
          })
        }
        if(el.dutyAttrCode === '423'){
          defaultValueObj[5] = defaultValFun(Number(el.dutyAttrAmountValue),optAttributeVal)
          dataObj[5] = optAttributeVal.map(item => {
            if(item == -1) {
              return {text:`不承保`,value:Number(item)}
            } else {
              return {text:`${item/10000}万${amountUnit}`,value:Number(item)}
            }
          })
        }
        
      })
    }

    // 意外伤害住院津贴
    if(dutyCode === 'CV01383'){
      dutyAttributeInfoList.map(el => {
        if(el.dutyAttrCode === '4'){
          let optAttributeVal = el.optionalAttributeValue.split(',')
          if(mustChoose === '1'){  //1,表示剔除不承保
            optAttributeVal[0] == 0 && optAttributeVal.splice(0, 1) //选项将 将0剔除  
          } else {
            (optAttributeVal[0] == 0) && optAttributeVal.splice(0, 1, -1); // 选项将 0改为-1
            (optAttributeVal[0] != -1) && optAttributeVal.unshift(-1)
          }
          el.dutyAttrAmountValue = el.dutyAttrAmountValue==0?-1:el.dutyAttrAmountValue
          for(let j = 0; j < professionType; j++){
            defaultValueObj[j] = defaultValFun(Number(el.dutyAttrAmountValue),optAttributeVal)
            dataObj[j] = optAttributeVal.map(item => {
              if(item == -1) {
                return {text:`不承保`,value:Number(item)} //-1对应的text是“不承保”
              } else {
                return {text:`${item}${amountUnit}`,value:Number(item)}
              }
            })
          }
          
        }
      })
    }

    // 自费药品费
    if(dutyCode === 'CV02476'){
      dutyAttributeInfoList.map(el => {
        if(el.dutyAttrCode === '28'){
          let optAttributeVal = el.optionalAttributeValue.split(',')
          if(mustChoose === '1'){  //1,表示剔除不承保
            optAttributeVal[0] == 0 && optAttributeVal.splice(0, 1) //选项将 将0剔除  
          } else {
            (optAttributeVal[0] == 0) && optAttributeVal.splice(0, 1, -1); // 选项将 0改为-1
            (optAttributeVal[0] != -1) && optAttributeVal.unshift(-1)
          }
          el.dutyAttrAmountValue = el.dutyAttrAmountValue==0?-1:el.dutyAttrAmountValue
          for(let j = 0; j < professionType; j++){
            defaultValueObj[j] = defaultValFun(Number(el.dutyAttrAmountValue),optAttributeVal);
            dataObj[j] = optAttributeVal.map(item => {
              if(item == -1) {
                return {text:`不承保`,value:Number(item)}
              } else {
                return {text:`${item/10000}万${amountUnit}`,value:Number(item)}
              }
            })
          }
        }
      })
    }
  }
  return {
    defaultValueObj,
    dataObj,
    optAttributeVal
  }
}

export const getTableDataForAli = (dutyInfo: any) => {
  let optAttributeVal = [-1, 0];
  if (!dutyInfo) {
    return {
      data: null,
      optAttributeVal
    }
  } else {
    let amount = (dutyInfo["amountArangeMap"] || {})["amount"] || 0;
    let data = [
      { text: "承保", value: amount }, //PL0700604 和 PL0700605默认值为1
      { text: "不承保", value: -1 },
    ];
    // 设置主险是否展示承保和不承保，子险是否显示隐藏
    if (dutyInfo["mustChoose"] == 1) {
      // 1-表示剔除不承保
      optAttributeVal = [amount];

      if (dutyInfo["isHideAmount"] == 1) {
        // 只显示 承保，不承保
        (dutyInfo["dutyAttributeInfoList"] || []).map((el) => {
          if (el.dutyAttrCode == dutyInfo["relationDutyCode"]) {
            data = optAttributeVal.map((item) => {
              return { text: `承保`, value: Number(item) };
            });
          }
        });
      } else if (dutyInfo["isHideAmount"] == 0) {
        // 可显示 不承保 带出默认值
        optAttributeVal = [amount];
        (dutyInfo["dutyAttributeInfoList"] || []).map((el) => {
          if (el.dutyAttrCode == dutyInfo["relationDutyCode"]) {
            optAttributeVal = el.optionalAttributeValue.split(",");
            if (el.optionalAttributeValue) {
              el.dutyAttrAmountValue =
                el.dutyAttrAmountValue == 0 ? -1 : el.dutyAttrAmountValue;
            } else {
              optAttributeVal[0] = amount; //选项将 0改为-1
            }
            data = optAttributeVal.map((item) => {
              if (item == 0) {
                return { text: `承保`, value: 0 }; //住院津贴 不承保也要传0
              } else {
                if (item / 10000 >= 1) {
                  return {
                    text: `${item / 10000}万${dutyInfo["amountUnit"]}`,
                    value: Number(item),
                  };
                } else {
                  return {
                    text: `${item}${dutyInfo["amountUnit"]}`,
                    value: Number(item),
                  };
                }
              }
            });
          }
        });
      }
    } else {
      //显示承保，不承保
      if (dutyInfo["isHideAmount"] == 1) {
        //只显示承保，不承保 不展示数值
        //optAttributeVal =['-1',amount] //选项将 0改为-1 //不展示下拉数据，只去不承保-1，承保-默认数值
        dutyInfo["dutyAttributeInfoList"].map((el) => {
          if (el.dutyAttrCode == dutyInfo["relationDutyCode"]) {
            //optAttributeVal=el.optionalAttributeValue.split(',')
            if (el.dutyAttrAmountValue != "0") {
              el.dutyAttrAmountValue =
                el.dutyAttrAmountValue == 0 ? -1 : el.dutyAttrAmountValue;
              optAttributeVal = [-1, amount];
            } else {
              //数据为0或者null
              optAttributeVal = [-1, 0]; //选项将 0改为-1
            }
          }
        });
      } else if (dutyInfo["isHideAmount"] == 0) {
        //按数值显示是否有显示承保，不承保或下拉列
        (dutyInfo["dutyAttributeInfoList"] || []).map((el) => {
          if (el.dutyAttrCode == dutyInfo["relationDutyCode"]) {
            optAttributeVal = el.optionalAttributeValue.split(",");
            if (
              optAttributeVal instanceof Array &&
              el.optionalAttributeValue.length > 0
            ) {
              //存在多个数值
              optAttributeVal.unshift(-1); //展示出 不承保按钮，optAttributeVal的值，下拉列表
            } else {
              //空数值
              if (amount == 0) {
                optAttributeVal[0] = -1; //选项将 0改为-1
              } else {
                optAttributeVal = [-1, amount]; //选项将 0改为-1
              }
            }

            data = optAttributeVal.map((item) => {
              if (item == -1) {
                return { text: `不承保`, value: -1 };
              } else {
                if (item / 10000 >= 1) {
                  return {
                    text: `${item / 10000}万${dutyInfo["amountUnit"]}`,
                    value: Number(item),
                  };
                } else {
                  return {
                    text: `${item}${dutyInfo["amountUnit"]}`,
                    value: Number(item),
                  };
                }
              }
            });
          }
        });
      }
    }
    return {
      data,
      optAttributeVal
    }
  }
}

export const extractContentWithinBrackets = (str:string) => {
  const regex = /\[([^\]]+)\]/g;
  const matches = str.match(regex);
  return matches ? matches.map(match => match.substring(1, match.length - 1)) : [];
}

export const getOptionalAttributeValueArr = (str?:string) => {
  const newStr = str || "";
  return newStr.split(",").filter(option => !!option);
}